import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { uuid } from "@ant-design/plots/es/utils";
import { Checkbox, Form, Input, Select, Table, Typography } from "antd";
import { PATTERNS, USER_TYPE } from "constants/appConstant";
import { getIn, useFormik } from "formik";
import { AuthInfo } from "stores/slices/auth";
import {
  doCreateBroadcastList,
  doGetListUpload,
  doUpdateBroadcastList,
} from "stores/slices/broadcastList";
import { doCreateCustomField } from "stores/slices/customField";
import { setIsRefresh } from "stores/slices/layout";
import { YupValidations } from "utils/validation";
import * as Yup from "yup";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";
// import FormInput from "components/forms/components/formInput";
import ModalForm from "components/forms/components/modalForm";
import SelectMultiple from "components/inputs/selectSearchSingle";

import { doAddCusomtersToBroadcastList } from "../../stores/slices/customer";

import styles from "../../components/styles.module.scss";

const listTitleStyle = {
  fontSize: 16,
  fontWeight: 500,
  borderBottom: "3px solid #5162F3",
  color: "#5162F3",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginBottom: 16,
};
const BroadcastListDetailTable = props => {
  const {
    broadcastListDetail,
    isCreate,
    onCancel,
    workspaceId,
    workspaceName,
    setIsData,
    columns,
    defaultColumns,
    customFields,
    isDefault,
    isImport,
    isUpdate,
    setIsOpenModalProgressing,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const formRef = React.useRef(null);
  const { id } = useParams();

  const [dataList, setData] = useState(broadcastListDetail.list || []);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [col, setCol] = useState([]);
  const [skipFirstLine, setSkipFirstLine] = useState(false);
  const [loading, setLoading] = useState(false);

  const [options, setOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [columnAddNew, setColumnAddNew] = useState("");
  const [newCustomField, setNewCustomField] = useState("");

  const authInfo = useSelector(AuthInfo);

  useEffect(() => {
    setData(broadcastListDetail.list);
    setPagination(pagination);
    setOptions([]);
    handleOptionsColumn();
  }, []);

  const [workspaceOption, setOptionWorkspace] = useState([]);

  useEffect(() => {
    if (workspaceId && workspaceName) {
      setOptionWorkspace([
        {
          key: workspaceId,
          label: workspaceName,
        },
      ]);
    }
  }, [workspaceId, workspaceName]);

  const inputItems = [
    {
      type: "text",
      key: "name",
      label: t("broadcastList.label.broadcastListName"),
      value: "",
      span: isCreate && dataList?.length > 0 ? 16 : 24,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          fontSize: "14px",
        },
        styleLabel: {
          fontWeight: "bold",
        },
      },
    },
    {
      type: "textarea",
      key: "description",
      label: t("broadcastList.label.description"),
      placeholder: "",
      value: "",
      span: isCreate && dataList?.length > 0 ? 16 : 24,
      style: {
        paddingBottom: 4,
        width: "100%",
      },
      config: {
        styleLabel: {
          fontWeight: "bold",
        },
        maxLength: 5000,
      },
    },
  ];

  const onFinish = async fieldsValue => {
    const params = {
      workspaceId:
        authInfo.workspaceId || workspaceId || fieldsValue.workspaceId,
      name: fieldsValue["fieldName"],
      isGetAll: true,
    };
    setLoading(true);
    const { payload } = await dispatch(doCreateCustomField(params));
    if (payload && payload.status === 200) {
      setLoading(false);
      setIsOpen(false);
      dispatch(setIsRefresh(uuid()));
      setNewCustomField(fieldsValue["fieldName"]);
    } else {
      setLoading(false);
    }
  };

  const onSubmitForm = async data => {
    setLoading(true);
    if (isCreate) {
      const result = await dispatch(
        doCreateBroadcastList({
          data: {
            workspaceId: workspaceId || broadcastListDetail.workspaceId,
            name: data.name,
            description: data.description,
            queries: {
              workspaceId: workspaceId || broadcastListDetail.workspaceId,
              page: 1,
              size: 10,
            },
          },
        })
      );
      if (result.payload.id) {
        const listCustomers = [];
        const cols = col.filter(cl => cl.key !== "ignore");
        dataList.forEach(item => {
          let customer = {
            create_customer_has_custom_field_requests: [],
          };
          cols.forEach(cl => {
            if (typeof cl.key === "number") {
              customer.create_customer_has_custom_field_requests.push({
                custom_field_id: cl.key,
                value: item[cl.dataIndex],
              });
            } else {
              customer[cl.key] = item[cl.dataIndex];
            }
          });
          listCustomers.push(customer);
        });
        // console.log("listCustomers", listCustomers);
        if (listCustomers.length > 100) {
          let count = Math.floor(listCustomers.length / 100);
          const surplus = listCustomers.length % 100;
          if (surplus > 0 && surplus < 100) {
            count++;
          }
          await dispatch(
            doGetListUpload({
              data: listCustomers,
              count: count,
              totalCount: count,
              broadcastListId: result.payload.id,
              workspaceId: workspaceId || broadcastListDetail.workspaceId,
            })
          );
          onCancel();
          setIsOpenModalProgressing(true);
        } else {
          await dispatch(
            doAddCusomtersToBroadcastList({
              broadcastListId: result.payload.id,
              createCustomerAndContactRequests: listCustomers,
              workspaceId:
                authInfo?.type === USER_TYPE.SUPER_ADMIN
                  ? broadcastListDetail.workspaceId
                    ? broadcastListDetail.workspaceId
                    : workspaceId
                  : "",
            })
          );
        }
      }
    } else {
      if (isImport) {
        const listCustomers = [];
        const cols = col.filter(cl => cl.key !== "ignore");
        dataList.forEach(item => {
          let customer = {
            create_customer_has_custom_field_requests: [],
          };
          cols.forEach(cl => {
            if (typeof cl.key === "number") {
              customer.create_customer_has_custom_field_requests.push({
                custom_field_id: cl.key,
                value: item[cl.dataIndex],
              });
            } else {
              customer[cl.key] = item[cl.dataIndex];
            }
          });
          listCustomers.push(customer);
        });
        if (listCustomers.length > 100) {
          let count = Math.floor(listCustomers.length / 100);
          const surplus = listCustomers.length % 100;
          if (surplus > 0 && surplus < 100) {
            count++;
          }
          await dispatch(
            doGetListUpload({
              data: listCustomers,
              count: count,
              totalCount: count,
              broadcastListId: !isDefault ? id : null,
              workspaceId: workspaceId || broadcastListDetail.workspaceId,
            })
          );
          onCancel();
          setIsOpenModalProgressing(true);
        } else {
          await dispatch(
            doAddCusomtersToBroadcastList({
              broadcastListId:
                authInfo?.type === USER_TYPE.SUPER_ADMIN
                  ? id
                  : !isDefault
                  ? id
                  : null,
              workspaceId:
                authInfo?.type === USER_TYPE.SUPER_ADMIN
                  ? broadcastListDetail.workspaceId
                    ? broadcastListDetail.workspaceId
                    : workspaceId
                  : "",
              createCustomerAndContactRequests: listCustomers,
              isImport: isImport,
            })
          );
        }
      } else {
        await dispatch(
          doUpdateBroadcastList({
            data: {
              workspaceId: workspaceId,
              name: data.name,
              description: data.description,
            },
            id: broadcastListDetail.id,
          })
        );
      }
    }
    onCancel();
    dispatch(setIsRefresh(uuid()));
    setLoading(false);
  };
  const validationSchema = Yup.object().shape({
    name: isImport ? Yup.string().nullable() : YupValidations.requiredString,
    description: Yup.string()
      .matches(PATTERNS.XSS_PATTERN, "validate.noxss")
      .max(5000, "validate.max_length_5000")
      .nullable(),
  });
  const BroadcastListForm = useFormik({
    initialValues: {
      name: "",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmitForm,
  });

  useEffect(() => {
    if (broadcastListDetail) {
      setValues({ ...broadcastListDetail });
    }
  }, [broadcastListDetail]);
  const { setValues, setFieldValue, handleSubmit, handleReset, values } =
    BroadcastListForm;

  useEffect(() => {
    const defaultOptions = defaultColumns.map(cl => {
      return {
        label: cl.title,
        value: cl.dataIndex,
      };
    });
    const customFieldOptions = customFields.map(cl => {
      return {
        label: cl.name,
        value: cl.id,
      };
    });
    const otherOptions = [
      {
        label: "Ignore",
        value: "ignore",
      },
    ];
    const newOptions = [
      {
        label: "Default",
        options: defaultOptions,
      },
      {
        label: "Custom Field",
        options: customFieldOptions,
      },
      {
        label: "Other",
        options: otherOptions,
      },
    ];
    setOptions(newOptions);
    if (col.length === 0) {
      drawColumns(columns);
    }
  }, [columns]);

  useEffect(() => {
    if (options.length > 0 && columnAddNew && newCustomField) {
      const newValue = customFields.find(cus => cus.name === newCustomField);
      handleChangeColumn(columnAddNew.key, columnAddNew.dataIndex, newValue.id);
    }
  }, [options]);

  useEffect(() => {
    if (options && col.length > 0) {
      drawColumns(col);
    }
  }, [options]);

  const drawColumns = columns => {
    let columnsHandle = columns.map(column => {
      column = {
        ...column,
        title: () => (
          <Select
            style={{
              display: "block",
              width: "200px",
            }}
            options={options}
            placeholder="Select"
            onSelect={value => {
              handleChangeColumn(column.key, column.dataIndex, value);
            }}
            defaultValue={column.key}
            value={column.key}
            dropdownRender={menu => (
              <>
                {menu}
                <AppButton
                  label={"+ Add"}
                  size={"medium"}
                  varient={"outlined"}
                  color={"primary"}
                  style={{
                    width: "100%",
                    minWidth: "auto",
                    border: "1px solid #f0f0f0",
                  }}
                  onClick={() => {
                    setIsOpen(true);
                    setColumnAddNew({
                      key: column.key,
                      dataIndex: column.dataIndex,
                    });
                  }}
                />
              </>
            )}
          />
        ),
      };
      return column;
    });
    // console.log("columnsHandle", columnsHandle);
    setCol(columnsHandle);
  };

  const handleChangeColumn = (
    currentKeyIndex,
    currentDataIndex,
    newOptions
  ) => {
    if (currentKeyIndex === newOptions) {
      return;
    }
    let newColumns = [...col];
    let currentKey = currentKeyIndex;
    let nextKey = newOptions;

    let currentId = newColumns.findIndex(
      cl => cl.key === currentKey && cl.dataIndex === currentDataIndex
    );
    let nextId =
      newOptions === "ignore"
        ? -1
        : newColumns.findIndex(cl => cl.key === nextKey);

    newColumns[currentId].key = newOptions;
    if (nextId !== -1) {
      newColumns[nextId].key = "ignore";
    }
    setCol(newColumns);
    drawColumns(col);
  };

  const handleOptionsColumn = () => {
    const defaultOptions = defaultColumns.map(cl => {
      return {
        label: cl.title,
        value: cl.dataIndex,
      };
    });
    const customFieldOptions = customFields.map(cl => {
      return {
        label: cl.name,
        value: cl.id,
      };
    });
    const otherOptions = [
      {
        label: "Ignore",
        value: "ignore",
      },
    ];
    const newColOptions = [
      {
        label: "Default",
        options: defaultOptions,
      },
      {
        label: "Custom Field",
        options: customFieldOptions,
      },
      {
        label: "Other",
        options: otherOptions,
      },
    ];
    setOptions(newColOptions);
  };

  const handleChange = queries => {
    setPagination({ ...pagination, ...queries });
  };
  const handleCheckBox = e => {
    setSkipFirstLine(e.target.checked);
  };
  useEffect(() => {
    const newData = broadcastListDetail.list;
    if (skipFirstLine) {
      setData(newData.filter((item, index) => index !== 0));
    } else {
      setData(newData);
    }
  }, [skipFirstLine]);

  const AddNewCustomFieldForm = () => {
    return (
      <Form
        ref={formRef}
        layout={"vertical"}
        initialValues={{
          fieldName: "",
        }}
        onFinish={onFinish}
      >
        {authInfo.type === USER_TYPE.SUPER_ADMIN && (
          <React.Fragment>
            <p className={styles.required} style={customFieldStyles.labelTitle}>
              {t("label.workspace")}
            </p>
            <Form.Item name="workspace">
              <SelectMultiple
                type={"select-search"}
                showSearch
                allowClear={false}
                optionFilterProp="children"
                options={workspaceOption}
                disabled={authInfo?.type === USER_TYPE.SUPER_ADMIN}
                onChange={value => {
                  formRef.current.setFieldsValue({
                    workspaceId: value,
                  });
                }}
                value={workspaceOption[0].key}
                defaultValue={workspaceOption[0].key}
                config={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </React.Fragment>
        )}
        <p className={styles.required} style={customFieldStyles.labelTitle}>
          {t("customField.fieldName")}
        </p>
        <Form.Item
          name="fieldName"
          rules={[
            { required: true, message: t("validate.required") },
            {
              pattern: new RegExp(PATTERNS.XSS_PATTERN),
              message: t("validate.noxss"),
            },
          ]}
        >
          <Input maxLength={255} />
        </Form.Item>
        <div style={customFieldStyles.buttonContainer}>
          <AppButton
            label={t("button.cancel")}
            color={"grey"}
            htmlType="button"
            onClick={() => {
              setIsOpen(false);
            }}
          />

          <AppButton
            label={t("button.add")}
            color={"blue"}
            type="primary"
            disabled={loading}
            htmlType="submit"
          />
        </div>
      </Form>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 1400,
        marginBottom: 24,
      }}
    >
      {broadcastListDetail.fileName && (
        <div style={{ marginBottom: 12 }}>
          <Typography style={{ color: "#0E9154" }}>
            {t("broadcastList.text.fileSuccess", {
              value: broadcastListDetail.fileName,
            })}
          </Typography>
          <Typography>
            {`${t("broadcastList.label.fileSize")}: `}
            <span style={{ fontWeight: "bold" }}>
              {broadcastListDetail.fileSize}
            </span>
          </Typography>
          <Typography>
            {`${t("broadcastList.label.fileContain")}: `}
            <span style={{ fontWeight: "bold" }}>
              {skipFirstLine
                ? `${parseInt(broadcastListDetail.fileContain) - 1} recipients`
                : broadcastListDetail.fileContain}
            </span>
          </Typography>
        </div>
      )}
      {isCreate && (
        <Typography style={listTitleStyle}>
          {t("broadcastList.title.listDetails")}
        </Typography>
      )}
      {isUpdate && (
        <FormInput
          items={inputItems.map(item => {
            item.label = t(item.label);
            if (item.key) {
              item.value = getIn(values, item.key);
            }
            return { ...item };
          })}
          form={BroadcastListForm}
          onChange={setFieldValue}
          layout={"vertical"}
        />
      )}
      {(isCreate || isImport) &&
        broadcastListDetail.list &&
        broadcastListDetail.list.length > 0 &&
        dataList && (
          <div style={{ witdh: "100%" }}>
            <Table
              style={{
                overflowX: "auto",
              }}
              columns={col}
              rowKey={() => uuid()}
              dataSource={dataList}
              pagination={pagination}
              onChange={handleChange}
            />
            <Checkbox onChange={e => handleCheckBox(e)}>
              {t("broadcastList.text.ignoreFirstLine")}
            </Checkbox>
          </div>
        )}
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginTop: "20px",
        }}
      >
        <AppButton
          label={t("label.cancel")}
          color={"grey"}
          loading={loading}
          type="button"
          onClick={() => {
            onCancel();
            handleReset();
            setValues();
            setIsData(false);
          }}
          size={"medium"}
          className={"cancelButton"}
        />
        <AppButton
          label={isCreate ? t("button.create") : t("button.save")}
          color={"blue"}
          loading={loading}
          type="submit"
          onClick={handleSubmit}
          size={"medium"}
        />
      </div>
      <ModalForm
        title={t("customField.addNewPopupTitle")}
        onCancel={() => setIsOpen(false)}
        isOpen={isOpen}
        footer={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <AddNewCustomFieldForm />
      </ModalForm>
    </div>
  );
};

const customFieldStyles = {
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 16,
    marginBottom: 16,
  },
};

export default BroadcastListDetailTable;
